module.exports = __webpack_public_path__ + "img/128.dd3bfbc3.jpg";